import React, { ReactNode } from 'react';
import { AddEntity } from '@shared/ui/add-entity';

interface MainLayoutProps {
  children: ReactNode;
  className?: string;
}

const MainLayout: React.FC<MainLayoutProps> & {
  Title: typeof Title;
  AddButton: typeof AddButton;
  Header: typeof Header;
  Main: typeof Main;
} = ({ children, className = '', ...props }) => (
  <div className={className} {...props}>{children}</div>
);

// Заголовок страницы теперь живёт в глобальной шапке (widgets/header),
// поэтому здесь оставляем no-op: API сохраняем, чтобы не править каждую
// страницу, но рендера нет — иначе на каждой странице получали бы
// дубликат заголовка прямо под белой шапкой.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Title: React.FC<{ children: ReactNode }> = (_props) => null;

interface AddButtonProps {
  children?: ReactNode;
  visible?: boolean;
  text: string;
  path: string;
  state?: any;
  [key: string]: any;
}

const AddButton: React.FC<AddButtonProps> = ({ children, visible = true, ...props }) => (
  <div className={`mb-4 ${visible ? 'visible' : 'invisible'}`}>
    {children ? children : <AddEntity {...props} />}
  </div>
);

const Header: React.FC<{ children: ReactNode; isVisible?: boolean }> = ({ children, isVisible = true }) => (
  <header className={`flex items-center justify-between mb-4 ${isVisible ? 'visible' : 'invisible'}`}>
    {children}
  </header>
);

const Main: React.FC<{ children: ReactNode }> = ({ children }) => (
  <main>{children}</main>
);

MainLayout.Title = Title;
MainLayout.AddButton = AddButton;
MainLayout.Header = Header;
MainLayout.Main = Main;

export default MainLayout;
